import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IAnalyticsFilter } from 'AnalyticsPackage/MainModule/interfaces/IAnalyticsFilter';
import { IKnmIndexPage } from 'APIPackage/KnmModule/interfaces/IKnmIndexPage';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiPost } from 'APIPackage/MainModule/common/apiTools';

import { IAnalyticsResponse } from '../interfaces/IAnalyticsResponse';

type AnalyticsFetchFilter = Omit<IAnalyticsFilter, 'kno' | 'year' | 'fromDate' | 'toDate'> & {
  knoIds?: string[];
  knoErvkUuids?: string[];
  year?: number;
  startDateBetween?: [string, string];
};

function mapFilter(filter: IAnalyticsFilter): AnalyticsFetchFilter {
  return {
    knoIds: filter.kno?.map(item => item.id) ?? undefined,
    knoErvkUuids:
      filter.kno?.map(item => item.ervkVersionUuid).filter((uuid): uuid is string => uuid !== undefined) ?? undefined,
    startDateBetween:
      filter.fromDate && filter.toDate
        ? [
            formatDate({ date: filter.fromDate, dateFormat: SYSTEM_DATE_FORMAT_FNS }) || '',
            formatDate({ date: filter.toDate, dateFormat: SYSTEM_DATE_FORMAT_FNS }) || '',
          ]
        : undefined,
    includeChildProsec: filter.includeChildProsec,
    year: filter.year?.id ? parseInt(filter.year.id, 10) : undefined,
    knmType: filter.knmType,
    nameAdminLevel: filter.nameAdminLevel,
  };
}

export async function fetchAnalytics(filter: IAnalyticsFilter): Promise<IAnalyticsResponse> {
  const data = mapFilter(filter);

  return apiPost<IAnalyticsResponse>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/analitics`,
    body: data,
  });
}

export async function exportAnalytics(filter: IAnalyticsFilter, format: ExportFormatsEnum): Promise<IExport> {
  const data = mapFilter(filter);

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/analitics/export?format=${format}`,
    body: data,
  });
}

const PAGE_SIZE = '50';

export async function fetchAnalyticsKnm(
  filter: IAnalyticsFilter,
  page: number,
  order?: string | null,
): Promise<IKnmIndexPage> {
  const data = mapFilter(filter);
  const params = new URLSearchParams();

  params.append('size', PAGE_SIZE);
  params.append('page', String(page));
  if (order) {
    params.append('order', order);
  }

  return apiPost<IKnmIndexPage>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/analitics/knm?${params}`,
    body: data,
  });
}

export async function exportAnalyticsKnm(filter: IAnalyticsFilter, format: ExportFormatsEnum): Promise<IExport> {
  const data = mapFilter(filter);

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/analitics/export/knm?format=${format}`,
    body: data,
  });
}
